var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-tasklists" },
    [
      _c("user-menu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "wrapper" },
        [
          _vm.admin ? _c("admin-sidebar-menu") : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "content-wrapper" }, [
            _c(
              "div",
              { staticClass: "container-wrapper center" },
              [
                _c("div", [
                  _c("h3", { staticClass: "d-inline heading" }, [
                    _vm._v("Group : " + _vm._s(_vm.groupName))
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "heading-seperator" }),
                _vm._v(" "),
                _c("div", { staticClass: "margin-bottom-10" }),
                _vm._v(" "),
                _c(
                  "b-card",
                  { attrs: { "no-body": "" } },
                  [
                    _c(
                      "b-tabs",
                      { attrs: { card: "" } },
                      [
                        _c("b-tab", {
                          attrs: {
                            title: "INSTRUCTORS",
                            active: _vm.isActive("Instructorlists")
                          },
                          on: {
                            click: function($event) {
                              return _vm.selected_component("Instructorlists")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("b-tab", {
                          attrs: {
                            title: "STUDENTS",
                            active: _vm.isActive("Studentlists")
                          },
                          on: {
                            click: function($event) {
                              return _vm.selected_component("Studentlists")
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(_vm.selectedComponent, {
                          tag: "component",
                          attrs: { groupId: _vm.groupId }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9d26a654", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9d26a654","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/primaryadmin/group_users.vue
// module id = null
// module chunks = 